import { AxiosRequestConfig } from "axios";
import {
  AcknowledgementsParams,
  AcknowledgementsResponse,
  getAcknowledgements,
  http,
} from "@/services";

export const requestAcknowledgements = (
  { EmpId, ActionId, ApplicationId }: AcknowledgementsParams,
  config?: AxiosRequestConfig,
) => {
  return http.get<AcknowledgementsResponse>(
    getAcknowledgements,
    {
      EmpId,
      ActionId,
      ApplicationId,
    },
    config,
    undefined,
    undefined,
    false,
  );
};
